const transitions = new WeakMap();

export async function enter(element, transitionName = null) {
    element.classList.remove('hidden');
    await transition('enter', element, transitionName);
}

export async function leave(element, transitionName = null) {
    await transition('leave', element, transitionName);
}

export async function toggle(element, transitionName = null) {
    const pending = transitions.get(element);
    if (pending ? pending.direction === 'leave' : element.classList.contains('hidden')) {
        await enter(element, transitionName);
    } else {
        await leave(element, transitionName);
    }
}

async function transition(direction, element, animation) {
    const dataset = element.dataset;
    const animationClass = animation ? `${animation}-${direction}` : direction;
    let transition = `transition${direction.charAt(0).toUpperCase() + direction.slice(1)}`;
    const genesis = dataset[transition] ? dataset[transition].split(' ') : [animationClass];
    const start = dataset[`${transition}Start`]
        ? dataset[`${transition}Start`].split(' ')
        : [`${animationClass}-start`];
    const end = dataset[`${transition}End`] ? dataset[`${transition}End`].split(' ') : [`${animationClass}-end`];

    const previous = transitions.get(element);
    if (previous) removeClasses(element, previous.classes);
    const current = { direction, classes: [...genesis, ...start, ...end] };
    transitions.set(element, current);
    addClasses(element, start);
    // Commit the starting style before enabling transitions. Otherwise Safari can
    // animate towards the start and immediately reverse it when the end is applied.
    element.getBoundingClientRect();
    addClasses(element, genesis);
    removeClasses(element, start);
    addClasses(element, end);
    await afterTransition(element);
    // An interrupted transition must not clean up or hide a newer transition.
    if (transitions.get(element) !== current) return;
    removeClasses(element, end);
    removeClasses(element, genesis);
    if (direction === 'leave') element.classList.add('hidden');
    transitions.delete(element);
}

function addClasses(element, classes) {
    element.classList.add(...classes);
}

function removeClasses(element, classes) {
    element.classList.remove(...classes);
}

function afterTransition(element) {
    // Cancellation is also completion: always remove the temporary transition classes.
    return Promise.allSettled(element.getAnimations().map((animation) => animation.finished));
}
